<template>
    <div class="footer">
        <el-tabs v-model="activeName" class="friendly-link" v-if="linkList.length > 0">
            <el-tab-pane label="友情链接" name="first">
                <div>
                    <div class="link-item" v-for="(link_item, link_index) in linkList" :key="link_index" :title="link_item.link_title">
                        <span @click="linkUrl(link_item.link_url, link_item.is_blank)"><img :src="$img(link_item.link_pic)" /></span>
                    </div>

                    <div class="clear"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div class="footer-top" v-if="shopServiceList.length > 0">
            <ul class="service">
                <li v-for="(item, index) in shopServiceList" :key="index">
                    <div v-if="item.icon">
                        <img :src="$img(item.icon)" alt="" />
                    </div>
                    <p>{{ item.service_name }}</p>
                </li>
            </ul>
        </div>

        <div class="footer-center" >
            <!-- <div class="left" v-if="siteInfo.web_phone || siteInfo.web_email">
                <div>
                    <p class="left-phone" v-if="siteInfo.web_phone">{{ siteInfo.web_phone }}</p>
                    <p class="left-email">{{ siteInfo.web_email }}</p>
                </div>
            </div>
            <div class="center" v-if="helpList.length">
                <div class="help" v-for="(item, index) in helpList" :key="index">
                    <p @click="clickToHelp(item.class_id)">{{ item.class_name }}</p>
                    <ul class="help-ul">
                        <template v-for="(helpItem, helpIndex) in item.child_list" >
                            <li class="help-li" :key="helpIndex" v-if="!helpItem.link_address" @click="clickToHelpDetail(helpItem.id)">{{ helpItem.title }}</li>
                            <li class="help-li" :key="helpIndex" v-else @click="clickJump(helpItem.link_address)">{{ helpItem.title }}</li>
                        </template>
                    </ul>
                </div>
            </div> -->
            <div class="left">
                <div style="display: flex;">
                    <el-image :src="siteInfo.logo" style="width: 233px; height: 98px;"></el-image>
                    <div style="padding-top: 25px;line-height: 1.5;margin-left: 20px;">
                        <p>投诉服务热线</p>
                        <p style="font-size: 40px;">{{ siteInfo.site_tel || '023-62397174' }}</p>
                    </div>
                </div>
                <div class="leftBottomBox">
                    <div class="itemBox" v-if="siteInfo.web_phone || siteInfo.web_email">
                        <img src="https://statics.sxhqt.com/bmall/home/icon_mall2x.png" class="img">
                        <div class="text">公司邮箱：{{siteInfo.web_phone || siteInfo.web_email}}</div>
                    </div>
                    <div class="itemBox">
                        <img src="https://statics.sxhqt.com/bmall/home/icon_enterprise2x.png" class="img">
                        <div class="text">公司名称：华医智药数字科技（重庆）有限公司</div>
                    </div>
                    <div class="itemBox">
                        <img src="https://statics.sxhqt.com/bmall/home/icon_add2x.png" class="img">
                        <div class="text">公司地址：重庆市南岸区长生桥镇金盏路11号3层</div>
                    </div>
                    <div class="itemBox">本网站不从事疫苗、血液制品、麻醉药品、精神药品、医疗用毒性药品、放射性药品、药品类易制毒化学品、医疗机构制剂等国家实行特殊管理的药品的产品交易。</div>
                </div>
            </div>
            <div class="right">
                <div class="image">
                    <el-image :src="require('@/assets/images/app_down_qrcode.png')"></el-image>
                    <p>下载App</p>
                </div>
                <div class="image">
                    <el-image :src="require('@/assets/images/wx_qrcode.jpg')"></el-image>
                    <p>微信小程序</p>
                </div>
            </div>
        </div>
        <div class="footer-bot" style="padding: 40px 0 20px;">
            <div class="center" style="display: grid;grid-template-columns: 1fr 2fr 1fr;gap: 16px; width: 1210px;margin: 0 auto;" v-if="helpList.length">
                <div class="help" v-for="(item, index) in helpList" :key="index">
                    <p style="font-weight: bold;" @click="clickToHelp(item.class_id)">{{ item.class_name }}</p>
                    <div class="help-ul" style="font-size: 90%;">
                        <template v-for="(helpItem, helpIndex) in item.child_list" >
                            <p class="help-li" :key="helpIndex" v-if="!helpItem.link_address">{{ helpItem.title }}</p>
                            <p class="help-li" style="cursor: pointer;" :key="helpIndex" v-else @click="clickJump(helpItem.link_address)">{{ helpItem.title }}</p>
                        </template>
                    </div>
                </div>
            </div>
            <div style="font-size: 90%;text-align: center;margin-top: 20px;">
                <span class="help-li" style="cursor: pointer;" @click="clickJump('https://beian.miit.gov.cn/')">渝ICP备2025076545号-1</span> 
                <span style="color: #838383;margin: 0 20px;"> | </span> 
                <span class="help-li" style="cursor: pointer;" @click="clickJump('http://www.beian.gov.cn/portal/registerSystemInfo')">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAFQklEQVRYw+3Wa1BUdRjH8SOpMeg4WhZGpDIxiaaTeUFgWrxE4AVRQJGlRRAVIV1JkbgMgQLi5AVBQSVLSp0xlEAUKBEEFZCrCstll8UV2AV2YbmoGCrYv31+R95UL5pmmtamZ+bz6rz5nvOc/5zDcX9jGLs/iTxuyvIlWYkRFeTHA2HVRFtzfhthTG5KuH96/vUgNlC4mMgyw1NJit/aAXLKazYje9xtIMZ/OZz50gW+9hcNkvoLEemEPbnrSP47QYwxQ5Ifv54RqzcXwFFvSyjaOhfavN8F7Y5ZcC/HH9JOB4LNa9Zw5YA76OZV8vIGMdZtSp7cDrtOnOavYiQhTAiPwi1AMtIQaqyngsxpBtw2GAGDKfaQmpUAa6xc4Vfp4UtEdzAMycsT9JQ1Tyctl/2eEkuTlYysF/rCUNxMqDEzgTqzSXBnpgnIHCzgjvEEuD52DLBr3rA1MAaWmNtB582wdtIljZ9G9D+IPU6aTxIPBjHCcXvg3CEh9K2fDLWvjIH6D6fwTIyheuwEqLUyhzLOALq8pkN+bgRw3HY4FBsMzxojZxP9DequLjAlQwVrbpIjhyIY4UYGQ/buhdBqPxlk3Gion2IMDQIz3kJe/ZS34I7uHkmD7VSQVgYDNyIAwsNCgfXGXoOBPjP9DKrOCAogA2etGTmTHAMcFwFZye7wS5QlVHGjoEw4A2qPCUBZ6AzNcQ5Q/YYRdO+YB1U3dsDwypLio4FJ3ECryIzWz6Cm3NgTRHN8HiPF6eHAGSbAdh8feFZkB7krzaHE9h2o85sDsiAbkIsXQMN+e2CtGyF0kzdwXCgU5++D/ouLQFV4OEU/g2Q/iNuIPNaKkQflAWBqexxGjhLDVUcL6IwSQN3SGVChe6FJg9dckCx6D1QBliDZLIAxo7eA8eyv4KE0BJqTrHkZvnL9DJKn+Twmt0NsGGHZy2Dn3kQYfsQ53Hh4/r4RNGz8AIpdzKEuaAF0RC2E57MmQgE3ATjuM/CPiANW7AqSfQJQ5vk362eQKmd3JrmXsoSRocpNIMnbB9zbceDIWUPmuHFQNMkISqa9DpUvNK6YDpW2s8DfwBK48WFQnhMCgzUBoLy0BrRVe5P0NWjPLdKUsJiR1tR1wGp8IeZwMgx/SrgRvjxuAziNcwLvyathLOcJHLflhRDYGRYFrNET2rJ5yvPLoas0tOj/oL8UpC4JHyTSU+6MNCS4gvKoAB5WiKG+MAQSg0WwLXQ/ZJ3xhao0FxB5hYCbUwAEfhEF3Td8QP2dAOQnPwFlxgrolUVq9TPoaX+ZB2nLc2Gk6awj1MU78HZZwJMid2Byb550JQwVO0NfxlJgdz14vWKeRAiK6DlQF28PLZdcoLNcBIO92bb6GTQ8Q/13RURT6tlH2gvXMlITLYD6uI+gp2ozdF0VQXumM6ivCqGvahM8kPiDItkeGo8tB025GFQ3xFrSr06zI3/4yde7oN7m0sWk5eKWDqK5JWJQvAHac9ygq3Adr9gTNNc3QG85rzPfHe5/7wDtPwuhp/Zz6CjyhaZzwi6ivfetHdH/oP77+3PJQOsuRnqkQdCa4wWqyx6gyecpL64GTaEX7ycXUJz4GJp1B4O0X/Hg0Xp1tFV+8Ei1k6c5coHofxBrrzQinbKYo0SVJ+wn6iurGHlY5gY911aDJnMFaHXXiDp9GQyvtKfUA9QFTtBZ7gPdit0tpFd9OpwwFmlA9D/o9yNLDpxIKmI8PMnNSNtviCLVpYTITzrXEGWaq4qos0WgOPdpCenIF+eRrurjB4k0PXopYZG6gMg/D/gNBUxhAbSAmKMAAAAASUVORK5CYII=" style="width: 16px;height: 16x;margin-right: 5px;">渝公网安备50010802006872号</span>
            </div>
        </div>
    </div>
</template>

<script>
import { copyRight, shopServiceLists, friendlyLink, weQrcode, websiteInfo , footerList } from "@/api/website"
import CopyRight from "./CopyRight"
import { mapGetters } from "vuex"
import { helpList } from "@/api/cms/help"

export default {
    props: {},
    data() {
        return {
            shopServiceList: [],
            linkList: [],
            helpList: [
                {
                    "class_name": "新手指南",
                    "child_list": [
                    {
                        "title": "用户隐私政策",
                        "link_address": "/cms/help-15"
                    },
                    {
                        "title": "退换货规则",
                        "link_address": "/cms/help-17"
                    },
                    {
                        "title": "用户协议",
                        "link_address": "/cms/help-16"
                    },
                    {
                        "title": "药品网络销售禁止清单",
                        "link_address": "/cms/help-18"
                    }
                    ]
                },
                {
                    "class_name": "关于我们",
                    "child_list": [
                    {
                        "title": "药品网络交易第三方平台备案信息：（渝）网药平台备字{2026}第000001-001号",
                        "link_address": "/cms/notice-19"
                    },
                    {
                        "title": "互联网药品医疗器械信息服务备案凭证：渝网药械信备字{2026}000092号",
                        "link_address": "/cms/notice-3"
                    },
                    {
                        "title": "网络食品交易第三方平台备案凭证：渝市监网食销备字〔2026〕第008号",
                        "link_address": "/cms/notice-20"
                    },
                    {
                        "title": "增值电信经营许可证：渝B2-20260070",
                        "link_address": "/cms/notice-1"
                    },
                    // {
                    //     "title": "公安备案号：渝公网安备50010802006872号",
                    //     "link_address": "http://www.beian.gov.cn/portal/registerSystemInfo"
                    // },
                    // {
                    //     "title": "ICP备案：渝ICP备2025076545号-1",
                    //     "link_address": "https://beian.miit.gov.cn/"
                    // }
                    ]
                },
                {
                    "class_name": "联系我们",
                    "child_list": [
                    {
                        "title": "营业执照",
                        "link_address": "/cms/notice-2"
                    },
                    {
                        "title": "国家药品监督管理局",
                        "link_address": "https://www.nmpa.gov.cn/"
                    },
                    {
                        "title": "重庆市药品监督管理局",
                        "link_address": "https://yaojianju.cq.gov.cn/"
                    },
                    // {
                    //     "title": "重庆市市场监督管理局",
                    //     "link_address": "https://scjgj.cq.gov.cn/"
                    // },
                    ]
                }
                ],
            ishide: false,
            activeName: "first",
            qrcode: "",
            websiteInfo: "",
            footerList:[],
        }
    },
    computed: {
        ...mapGetters(["siteInfo"])
    },
    created() {
        this.getShopServiceLists();
        this.link();
        // this.getHelpList();
        // this.getqrcodeimg();
        this.getWebSiteInfo();
        this.$nextTick(() => {
            console.log("copyRight" , this.siteInfo);
        })
    },
    mounted() {},
    watch: {},
    methods: {
        getFooterList() {
            footerList().then((res) => {
                if (res.code === 0) {
                    this.footerList = res.data
                }
            })
        },
        getqrcodeimg() {
            weQrcode({})
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.qrcode = res.data
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message)
                })
        },
        getShopServiceLists() {
            shopServiceLists({})
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.shopServiceList = res.data
                    }
                })
                .catch((err) => {
                    this.shopServiceList = []
                })
        },
        link() {
            friendlyLink({})
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.linkList = res.data
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message)
                })
        },
        linkUrl(url, target) {
            if (!url) return
            if (url.indexOf("http") == -1) {
                if (target)
                    this.$router.pushToTab({
                        path: url
                    })
                else
                    this.$router.push({
                        path: url
                    })
            } else {
                if (target) window.open(url)
                else window.location.href = url
            }
        },
        /**
         * 获取帮助列表
         */
        getHelpList() {
            helpList()
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        var arr = []
                        arr = res.data.slice(0, 4)
                        for (let i = 0; i < arr.length; i++) {
                            arr[i].child_list = arr[i].child_list.slice(0, 4)
                        }
                        this.helpList = arr
                    }
                })
                .catch((err) => {})
        },
        //底部电话等信息
        getWebSiteInfo() {
            websiteInfo()
                .then((res) => {
                    this.websiteInfo = res.data
                })
                .catch((err) => {})
        },
        /**
         * 图片加载失败
         */
        imageError() {
            this.siteInfo.web_qrcode = "../../assets/images/wxewm.png"
        },
        /**
         * 跳转到帮助列表
         */
        clickToHelp(id) {
            this.$router.push("/cms/help/listother-" + id)
        },
        /**
         * 跳转到帮助详情
         */
        clickToHelpDetail(id) {
            this.$router.push("/cms/help-" + id)
        },
        /**
         * 跳转到帮助详情
         */
        clickJump(address) {
            if(address){
                if(address.indexOf('://')<=6){
                    window.open(address, '_blank');
                }else{
                    this.$router.push(address)
                }
            }
        }
    },
    components: {
        CopyRight
    }
}
</script>

<style scoped lang="scss">
.footer {
    // background-color: #242424;
    // color: #d8d8d8;
    background-color: var(--foot-bg-color , #f3f8f7e6);
    color: var(--foot-color , #242424);
    min-width: 1210px;
    // color: $base-color;
    .footer-top {
        // background-color: #fff;
        .service {
            margin: 0;
            padding: 0;
            width: $width;
            margin: 0 auto;
            padding: 40px 0 20px;
            box-sizing: border-box;
            border-bottom: 1px solid #838383;
            display: flex;
            justify-content: space-around;
            align-items: center;
            li {
                list-style: none;
                line-height:40px;
                text-align: center;
                flex: 1;

                div {
                    width: 48px;
                    height: 48px;
                    line-height: 48px;
                    display: flex;
                    overflow: hidden;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;

                    img {
                        height: 100%;
                    }
                }
                p {
                    font-size: 16px;
                    line-height: 20px;
                    margin-top: 10px;
                }
            }
        }
    }

    .footer-center {
        width: $width;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 40px 0 20px;
        border-bottom: 1px solid #838383;
        // font-weight: bold;
        .left {
            flex:1;

            .left-phone {
                font-size: 26px;
                font-weight: 600;
                padding-bottom: 10px;
                border-bottom: 1px solid $base-color;
                margin-bottom: 12px;
            }
            .left-email {
                font-size: 18px;
            }
            .leftBottomBox .itemBox{
                display: flex;
                align-items: center;
                margin-top: 10px;
                line-height: 1.2;
                .img{
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                }
            }
        }
        .right {
            text-align: center;
            display: flex;
            justify-content: flex-end;
            .image{
                overflow: hidden;
                margin-left: 20px;
                .el-image {
                    padding: 20px;
                    background-color: #fff;
                    width: 115px;
                    height: 115px;
                    line-height: 115px;
                    text-align: center;
                    border-radius: 10px;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
            }
        }

        .qrcode-hide {
            display: none;
        }
    }
    .friendly-link {
        width: $width;
        margin: 0 auto;
        border: 1px solid #e9e9e9;

        .link-title {
            line-height: 30px;
            padding: 10px 0 5px;
            margin: 0px 0 15px;
            border-bottom: 1px solid #e8e8e8;
        }
        .link-item {
            width: 10%;
            height: 40px;
            line-height: 47px;
            float: left;
            text-align: center;
            overflow: hidden;
            margin: 0 6px 10px 6px;
            -webkit-transition: opacity 0.3s, box-shadow 0.3s;
            transition: opacity 0.3s, box-shadow 0.3s;
            border: 1px solid #fff;
            border-left: none;
            cursor: pointer;
        }
        .link-item:hover {
            width: -webkit-calc(10% + 1px);
            width: calc(10% + 1px);
            margin-left: 4px;
            position: relative;
            opacity: 1;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            border: 1px solid #dddddd;
        }
        .clear {
            clear: both;
        }
    }
}
</style>
<style lang="scss">
.friendly-link {
    .el-tabs__nav-scroll {
        padding-left: 30px;
        height: 50px;
        line-height: 50px;
    }
    .el-tabs__content {
        padding: 0 20px;
    }
    .el-tabs__nav-wrap::after {
        height: 1px;
    }
    .el-tabs__nav {
        padding: 0 20px;
    }
    .el-tabs__active-bar {
        padding: 0 20px;
    }
}
</style>
